export interface IAdminDataValidation {
    alias: boolean,
    invoicePoStartDate: boolean,
    invoicePoExpirationDate: boolean,
    latitude: boolean,
    longitude: boolean,
    routingNumber: boolean,
    packagingRoutingNumber: boolean
}